import React, { Fragment, useState } from "react";
import Ellipse from "./Ellipse";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
// import RightSideBar from "./RightSideBar";
// import ChatBox from "../ChatBox";
import RightSidebar from "./right-side-bar/RightSideBar";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  const [showRightSidebar , setShowRightSidebar] = useState();
  const showRightSidebarFunc = () => {
    setShowRightSidebar(!showRightSidebar)
  }
  return (
    <Fragment>
	  <Ellipse />	
      <RightSidebar
        showRightSidebar={showRightSidebar}
      />
      <NavHader />
	  <Header
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
        showRightSidebar={showRightSidebarFunc}
      /> 
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
